import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentCounsellingReportRoutingModule } from './student-counselling-report-routing.module';
import { StudentCounsellingReportComponent } from './student-counselling-report/student-counselling-report.component';
import { StudentCounsellingReportLandingComponent } from './student-counselling-report-landing/student-counselling-report-landing.component';
import { StudentCounsellingReportLinkComponent } from './student-counselling-report-link/student-counselling-report-link.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StudentCounsellingReportDialogComponent } from './student-counselling-report-dialog/student-counselling-report-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AgGridModule } from 'ag-grid-angular';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { environment } from 'src/environments/environment';
import { StudentreportDialogComponent } from './studentreport-dialog/studentreport-dialog.component';

ModuleRegistry.registerModules([AllEnterpriseModule]);
 
LicenseManager.setLicenseKey(environment.ag_grid_key);
@NgModule({
  declarations: [
    StudentCounsellingReportComponent,
    StudentCounsellingReportLandingComponent,
    StudentCounsellingReportLinkComponent,
    StudentCounsellingReportDialogComponent,
    StudentreportDialogComponent
  ],
  imports: [
    CommonModule,
    StudentCounsellingReportRoutingModule,
    AcademicFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AgGridModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class StudentCounsellingReportModule { }
